// Shared assets for the report card template.
export const GOLD_SEAL_URL =
  "https://customer-assets.emergentagent.com/job_paw-some-reports/artifacts/4wy1bqyc_ChatGPT%20Image%20Jul%2011%2C%202026%2C%2007_29_18%20PM.png";
